function checkAll($label){
    setTimeout(function () {
        if($label.find('.input--checkbox').is(':checked')){
            $label.parents('.tab-pane').find('.comment__check .input--checkbox').prop('checked', true);
            $label.parents('.tab-pane').find('.comment').addClass('comment--checked');
        }else {
            $label.parents('.tab-pane').find('.comment__check .input--checkbox').prop('checked', false);
            $label.parents('.tab-pane').find('.comment').removeClass('comment--checked');
        }
    },100);
}
function check($checkbox){
    setTimeout(function () {
        if($checkbox.find('.input--checkbox').is(':checked')){
            $checkbox.parents('.comment').addClass('comment--checked');
        }else {
            $checkbox.parents('.comment').removeClass('comment--checked');
        }
    },100);
}
function init() {
    if ($('.comment__check').length > 0) {
        $('.check-all').click(function () {
            checkAll($(this));
        });
        $('.comment__check').click(function () {
            check($(this));
        });
        $('.comment--checked .input--checkbox').prop('checked', true);
    }
}
$(function() {
    init();
});
